<template>
  <section class="flex level-1" :class="{mobile:isMobile}">

    <!-- //TITLE MOBILE -->
      <div class="mobile"  :class="{isMobile:isMobile}" v-if="mobile">
        <div class="link">
          <button class="bt btn-back" @click="goBack()">
          <font-awesome-icon :icon="['far', 'times']"/>
          </button>
          <PuSkeleton :loading="isLoading" :count="1" width='140px'>
            <h2>{{content.title}}</h2>
          </PuSkeleton>
        </div>
        <div class="sep"></div>
      </div>
    <!-- //TITLE MOBILE -->

    <!-- CONTENT-->
    <div class="block__news content__shop">

      <!-- PART MIDDLE -->
      <div class="column-middle">
      <b-breadcrumb class="desktop">
          <b-breadcrumb-item @click.prevent="goBack" >{{general.home}}</b-breadcrumb-item>
          <b-breadcrumb-item active>{{content.title}}</b-breadcrumb-item>
        </b-breadcrumb>

      <div class="sep desktop"></div>
      <Stack></Stack>

        <div class="header entete">
          <PuSkeleton :loading="isLoading" :count="1" width='140px'>
            <p>{{content.title}}</p>
          </PuSkeleton>
        </div>

        <PuSkeleton :loading="isLoading" :count="1" width='100%' height="300px" v-if="image">
          <imageLoader
              :img = image
              theMinHeight = '300px'
          ></imageLoader>
        </PuSkeleton>


        <section class="wrapper">
          <PuSkeleton :loading="isLoading" :count="10">
            <div class="content_desc" v-html="content.content">
            </div>
          </PuSkeleton>
        </section>


      </div>
      <!-- PART MIDDLE -->
      <!-- PART RIGHT -->
      <div class="col-right column-right borderLeft text-left">
        <b-col v-for="(news,index) in theNews" :key="`${index}-${news.id}`">
          <cardPost
            :title = news.title
            :desc = news.accroche
            :link = news.id
            :date = news.publishDate
            :isLoad.sync = isLoadingNews
          />
          <Stack></Stack>
        </b-col>
      </div>
      <!-- PART RIGHT -->
    </div>
    <!-- CONTENT-->

  </section>
</template>


<script>
import { mapGetters } from 'vuex'
// import cardPoint from '../../../module/card/CardPoint'
import ApiService from '../../../../services/ApiService'
import cardPost from '../../../module/card/CardPost'
import Stack from '../../../module/stack/Stack'
import imageLoader from '../../../module/picture/imageLoader'

export default {
  name:"challengeNews",
    components:{
      cardPost,
      Stack,
      imageLoader
      // SidebarChallenges
    },
    computed: {
      ...mapGetters([
        'getGeneral',
        'getChallengeSelected',
          'getIsMobile'
      ])
    },
    data () {
      return {
        content:"",
        general:"",
        isLoading:true,
        isLoadingNews:true,
        isMobile:false,
        image: null,
        theNews:[{},{},{}],
      }
    },
    props:{
      mobile:{
        type:Boolean,
        default:true
      }
    },
    created (){
      this.getData().then(() => {
        this.isLoading = false;
        this.isLoadingNews = false;
      });
      this.general = this.getGeneral;
      this.isMobile = this.getIsMobile;
      this.$store.dispatch('showFooter',false);
    },
    methods : {
      goBack() {
        this.$store.dispatch('goBack');
        if (this.isMobile) {
            this.$router.push({name: "mobile", params: { subcat: 0 }})
            this.$store.dispatch('showFooter',true);
        } else {
          this.$router.push({name: "challenges-accueil"});
        }
      },

      async getData(){
        let promises = [];
        if (this.getChallengeSelected){
          promises.push(ApiService.getConcoursApi().getNewsList(this.getChallengeSelected).then((data) => {
            this.theNews = data.data;
          }));
        }
        if (this.$route.params.userId){
          promises.push(ApiService.getConcoursApi().getNewsDetail(this.$route.params.userId).then((data) => {
            this.content = data.data;
            if (this.content.image){
              this.image = ApiService.getMediaApi().get(this.content.image.id);
            } else {
              this.image = null;
            }
          }));
        }
        if (promises.length > 0){
          await Promise.all(promises);
        }
      }
    },
    watch: {
        '$route.params.userId': function () {
          this.isLoading = true;
          this.isLoadingNews = true;
          this.getData().then(() => {
            this.isLoading = false;
            this.isLoadingNews = false;
          });
        },
        getIsMobile(){
            this.isMobile = this.getIsMobile;
        }
      },
};
</script>
